import React from "react";
import styled from "styled-components";
import {
    read_timeline_date_label,
    read_timeline_value_label
} from "../../utils/timeline/timeline_formatting";
import { read_timeline_plain_text } from "../../utils/timeline/timeline_normalization";

const TimelineCommunication = styled.div`
    display: grid;
    gap: 0.6rem;
    min-width: 0;

    h5, p {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

const TimelineCommunicationComments = styled.div`
    display: grid;
    gap: 0.6rem;
`;

const TimelineCommunicationComment = styled.div`
    display: grid;
    gap: 0.4rem;
    padding-left: 1rem;
    border-left: 0.2rem solid ${p => p.theme.low};

    h6 {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
    }
`;

const read_communication_actor_keys = (actor) => {
    return [actor?.userId, actor?.id, actor?._id, actor?.email, actor?.username, ...(actor?.aliases || []), actor?.name?.includes("@") ? actor.name : "", typeof actor === "string" ? actor : ""]
        .map((value) => String(value || "").trim().toLowerCase())
        .filter((value) => value && !["system", "unknown author"].includes(value));
};

// Only omit metadata already visible on the block; names alone cannot establish identity.
const read_communication_comment_meta = (comment, metadataEvent, t) => {
    const actor = comment?.by || comment?.author || comment?.createdBy || comment?.user;
    const parentActor = metadataEvent?.by;
    const actorId = actor?.userId || actor?.id || actor?._id;
    const parentId = parentActor?.userId || parentActor?.id || parentActor?._id;
    const conflictingIds = actorId && parentId && actorId !== parentId;
    const parentKeys = read_communication_actor_keys(parentActor);
    const sameActor = !conflictingIds && read_communication_actor_keys(actor).some((key) => parentKeys.includes(key));
    const date = read_timeline_date_label(comment?.createdAt || comment?.updatedAt);
    const sameDate = date && date === read_timeline_date_label(metadataEvent?.changedAt);

    if (sameActor && sameDate) {
        return "";
    }

    return [read_timeline_value_label(actor, t("Unknown author")), date || t("Date unavailable")].join(" · ");
};

export default function Timeline_Communication(props) {
    const title = read_timeline_value_label(props.event?.data?.issue?.title, "") || props.t("Communication");
    const description = read_timeline_plain_text(props.event?.data?.issue?.description || props.event?.note);
    const comments = (props.event?.data?.issue?.comments || []).map((comment, index) => ({
        key: comment?.id || comment?._id || `${props.event?.sourceKey}-comment-${index}`,
        meta: read_communication_comment_meta(comment, props.metadataEvent || props.event, props.t),
        body: read_timeline_plain_text(comment?.body || comment?.comment || comment?.message || comment?.text || comment?.description)
    }));

    return (
        <TimelineCommunication>
            <h5>{title}{props.event?.data?.issue?.issueCode ? <span> · {props.event.data.issue.issueCode}</span> : null}</h5>
            {description && description !== title && description.toUpperCase() !== "COMMUNICATION" ? <p>{description}</p> : null}
            {comments.length ? (
                <TimelineCommunicationComments>
                    {comments.map((comment) => (
                        <TimelineCommunicationComment key={comment.key}>
                            {comment.meta ? <h6>{comment.meta}</h6> : null}
                            {comment.body ? <p>{comment.body}</p> : null}
                        </TimelineCommunicationComment>
                    ))}
                </TimelineCommunicationComments>
            ) : null}
        </TimelineCommunication>
    );
}

export { Timeline_Communication };
